var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ small: _vm.small },attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":_vm.onClick}},[(_vm.loading)?_c('UPreloader',{attrs:{"size":"30"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }